export const otherUserPermission = {
  addColumn: false,
};
